import { routes } from "common/navigationRoutes"
import React from "react"

export const sharedRoutes = [
  {
    key: "invoice",
    path: routes.INVOICE,
    component: React.lazy(() =>
      import(/* webpackChunkName: "invoice" */ "pages/student/invoices/Invoice")
    ),
  },
]

export const publicRoutes = [
  {
    key: "login",
    path: routes.LOGIN,
    component: React.lazy(() =>
      import(/* webpackChunkName: "auth" */ "pages/Auth/Login/Login")
    ),
  },
  {
    key: "forgotPassword",
    path: routes.FORGOT_PASSWORD,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "auth" */ "pages/Auth/ForgotPassword/ForgotPassword"
      )
    ),
  },
  {
    key: "resetPassword",
    path: routes.RESET_PASSWORD,
    component: React.lazy(() =>
      import(/* webpackChunkName: "auth" */ "pages/Auth/ResetPassword")
    ),
  },
  {
    key: "account",
    path: routes.ACCOUNT,
    component: React.lazy(() =>
      import(/* webpackChunkName: "auth" */ "pages/Auth/Account")
    ),
  },
  {
    key: "scanQr",
    path: routes.SCAN_QR,
    component: React.lazy(() =>
      import(/* webpackChunkName: "auth" */ "pages/Auth/ScanQRCode/ScanQRCode")
    ),
  },
  {
    key: "classCode",
    path: routes.CLASS_CODE,
    component: React.lazy(() =>
      import(/* webpackChunkName: "auth" */ "pages/Auth/ClassCode/ClassCode")
    ),
  },
]

export const privateRoutes = [
  {
    key: "account",
    path: routes.ACCOUNT,
    component: React.lazy(() =>
      import(/* webpackChunkName: "account" */ "pages/Auth/Account")
    ),
  },
  {
    key: "groups",
    path: routes.GROUPS,
    component: React.lazy(() =>
      import(/* webpackChunkName: "groups" */ "pages/student/groups")
    ),
  },
  {
    key: "activity",
    path: routes.ACTIVITY,
    component: React.lazy(() =>
      import(/* webpackChunkName: "activity" */ "pages/student/activity")
    ),
  },
  {
    key: "student",
    path: routes.STUDENT,
    component: React.lazy(() =>
      import(/* webpackChunkName: "student" */ "pages/student/home")
    ),
  },
  {
    key: "memorama",
    path: routes.MEMORAMA,
    component: React.lazy(() =>
      import(/* webpackChunkName: "memorama" */ "pages/student/games/Memorama")
    ),
  },
  {
    key: "wordSearch",
    path: routes.WORD_SEARCH,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "wordSearch" */ "pages/student/games/WordSearch"
      )
    ),
  },
  {
    key: "crosswords",
    path: routes.CROSSWORDS,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "crosswords" */ "pages/student/games/Crosswords"
      )
    ),
  },
  {
    key: "games",
    path: routes.GAMES,
    component: React.lazy(() =>
      import(/* webpackChunkName: "games" */ "pages/student/smashgames")
    ),
  },
  {
    key: "newgames",
    path: routes.NEW_GAMES,
    component: React.lazy(() =>
      import(/* webpackChunkName: "newgames" */ "pages/games/Games")
    ),
  },
  {
    key: "fixItRushGame",
    path: routes.FIX_IT_RUSH_GAME,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "fixItRushGame" */ "pages/games/arcadeGame/FixItRush"
      )
    ),
  },
  {
    key: "listeningRaceGame",
    path: routes.LISTENING_RACE_GAME,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "listeningRaceGame" */ "pages/games/arcadeGame/ListeningRace"
      )
    ),
  },
  {
    key: "phraseMasterGame",
    path: routes.PREPOSITION_MASTER_GAME,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "phraseMasterGame" */ "pages/games/arcadeGame/PhraseMaster"
      )
    ),
  },
  {
    key: "sentenceShift",
    path: routes.SENTENCE_SHIFT,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "sentenceShift" */ "pages/games/arcadeGame/SentenceShift"
      )
    ),
  },
  {
    key: "phraseBuilderGame",
    path: routes.PHRASE_BUILDER_GAME,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "phraseBuilderGame" */ "pages/games/arcadeGame/PhraseBuilder"
      )
    ),
  },
  {
    key: "wordRecallChallengeGame",
    path: routes.WORD_RECALL_CHALLENGE_GAME,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "wordRecallChallengeGame" */ "pages/games/arcadeGame/WordRecallChallenge"
      )
    ),
  },
  {
    key: "flashcardBlitzGame",
    path: routes.FLASHCARD_BLITZ_GAME,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "flashcardBlitzGame" */ "pages/games/arcadeGame/FlashcardBlitz"
      )
    ),
  },
  {
    key: "sentenceScrambleGame",
    path: routes.SENTENCE_SCRAMBLE,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "sentenceScrambleGame" */ "pages/games/arcadeGame/SentenceScramble"
      )
    ),
  },
  {
    key: "wordMatchGame",
    path: routes.WORD_MATCH_GAME,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "wordMatchGame" */ "pages/games/arcadeGame/WordMatch"
      )
    ),
  },
  {
    key: "scenarioSnapGame",
    path: routes.SCENARIO_SNAP,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "scenarioSnapGame" */ "pages/games/arcadeGame/ScenarioSnap"
      )
    ),
  },
  {
    key: "translationDuelGame",
    path: routes.TRANSLATION_DUEL,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "translationDuelGame" */ "pages/games/arcadeGame/TranslationDuel"
      )
    ),
  },
  {
    key: "memoryPalaceGame",
    path: routes.MEMORY_PALACE,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "memoryPalaceGame" */ "pages/games/arcadeGame/MemoryPalace"
      )
    ),
  },
  {
    key: "wordHuntGame",
    path: routes.WORD_HUNT,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "wordHuntGame" */ "pages/games/arcadeGame/WordHunt"
      )
    ),
  },
  {
    key: "crosswordQuestGame",
    path: routes.CROSSWORD_QUEST,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "crosswordQuestGame" */ "pages/games/arcadeGame/CrosswordQuest"
      )
    ),
  },
  {
    key: "wordMazeGame",
    path: routes.WORD_MAZE,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "wordMazeGame" */ "pages/games/arcadeGame/WordMaze"
      )
    ),
  },
  {
    key: "conversationLabGame",
    path: routes.CONVERSATION_LAB,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "conversationLabGame" */ "pages/games/arcadeGame/ConversationLab"
      )
    ),
  },
  {
    key: "grades",
    path: routes.GRADES,
    component: React.lazy(() =>
      import(/* webpackChunkName: "grades" */ "pages/student/grades")
    ),
  },
  {
    key: "chooseGames",
    path: routes.CHOOSE_GAMES,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "chooseGames" */ "pages/student/smashgames/ChooseGamePage"
      )
    ),
  },
  {
    key: "placements",
    path: routes.PLACEMENTS,
    component: React.lazy(() =>
      import(/* webpackChunkName: "placements" */ "pages/student/placements")
    ),
  },
  {
    key: "levelDetail",
    path: routes.PLACEMENTS_LEVEL,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "levelDetail" */ "pages/student/placements/level"
      )
    ),
  },
  {
    key: "teacherGrades",
    path: routes.TEACHER_GRADES,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "teacherGrades" */ "pages/student/teacherGrades"
      )
    ),
  },
  {
    key: "missions",
    path: routes.MISSIONS,
    component: React.lazy(() =>
      import(/* webpackChunkName: "missions" */ "pages/student/missions")
    ),
  },
  {
    key: "wordsEmoji",
    path: routes.WORDS_EMOJI,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "wordsEmoji" */ "pages/student/games/WordsEmoji"
      )
    ),
  },
  {
    key: "tickets",
    path: routes.TICKETS,
    component: React.lazy(() =>
      import(/* webpackChunkName: "tickets" */ "pages/student/tickets")
    ),
  },
  {
    key: "reader",
    path: "reader",
    component: React.lazy(() =>
      import(/* webpackChunkName: "reader" */ "pages/student/reader")
    ),
  },
  {
    key: "avatar",
    path: routes.AVATAR,
    component: React.lazy(() =>
      import(/* webpackChunkName: "avatar" */ "pages/Auth/Avatar")
    ),
  },
  {
    key: "avatarPiece",
    path: routes.AVATAR_PIECE,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "avatarPiece" */ "pages/Auth/Avatar/PiecePage"
      )
    ),
  },
  {
    key: "rewards",
    path: routes.REWARDS,
    component: React.lazy(() =>
      import(/* webpackChunkName: "rewards" */ "pages/student/rewards")
    ),
  },
  {
    key: "rewardsItem",
    path: routes.REDWARDS_ITEM,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "rewardsItem" */ "pages/student/rewards/RewardsItem"
      )
    ),
  },
  {
    key: "onboarding",
    path: routes.ONBOARDING,
    component: React.lazy(() =>
      import(/* webpackChunkName: "onboarding" */ "pages/Auth/Onboarding")
    ),
  },
  {
    key: "fontSettings",
    path: routes.FONT_SETTINGS,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "fontSettings" */ "pages/Auth/TextSettingsPage"
      )
    ),
  },
  {
    key: "messages",
    path: routes.TEACHER_MESSAGES,
    component: React.lazy(() =>
      import(/* webpackChunkName: "teacherMessages" */ "pages/student/messages")
    ),
  },
  {
    key: "announcements",
    path: routes.ANNOUNCEMENTS,
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "announcements" */ "pages/student/announcements"
      )
    ),
  },
  {
    key: "invoices",
    path: routes.INVOICES,
    component: React.lazy(() =>
      import(/* webpackChunkName: "invoices" */ "pages/student/invoices")
    ),
  },
  {
    key: "training",
    path: routes.TRAINING,
    component: React.lazy(() =>
      import(/* webpackChunkName: "training" */ "pages/student/training")
    ),
  },
  {
    key: "surveys",
    path: routes.SURVEYS,
    component: React.lazy(() =>
      import(/* webpackChunkName: "surveys" */ "pages/student/surveys")
    ),
  },
]

export const professorPrivateRoutes = [
  {
    key: "professor-account",
    path: "account",
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "professor-account" */ "pages/professor/Account"
      )
    ),
  },
  {
    key: "professor-feed",
    path: "feed",
    component: React.lazy(() =>
      import(/* webpackChunkName: "professor-feed" */ "pages/professor/Feed")
    ),
  },
  {
    key: "professor-missions",
    path: "missions",
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "professor-missions" */ "pages/professor/Missions"
      )
    ),
  },
  {
    key: "professor-students",
    path: "students",
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "professor-students" */ "pages/professor/Students"
      )
    ),
  },
  {
    key: "professor-students-add-options",
    path: "students/add/options",
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "professor-students-add" */ "pages/professor/Students/AddStudents/Options"
      )
    ),
  },
  {
    key: "professor-grades",
    path: "grades",
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "professor-grades" */ "pages/professor/Grades"
      )
    ),
  },
  {
    key: "professor-groups",
    path: "groups",
    component: React.lazy(() =>
      import(
        /* webpackChunkName: "professor-groups" */ "pages/professor/Groups"
      )
    ),
  },
]
